// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host-context(.no-padding) .content {
  padding: 0;
}

.content {
  overflow: hidden;
}

.header {
  display: flex;
  width: 100%;
}

.titlebar {
  align-items: baseline;
  padding: 16px;
}

.back-button {
  cursor: pointer;
  text-align: center;
  width: 24px;
}
.back-button spx-icon {
  height: 24px;
  padding: 0;
  width: 24px;
}

.page-title {
  margin-left: 8px;
}

.back-icon {
  padding-left: 16px;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImxheW91dC5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDRTtFQUNFLFVBQUE7QUFBSjs7QUFJQTtFQUNFLGdCQUFBO0FBREY7O0FBSUE7RUFDRSxhQUFBO0VBQ0EsV0FBQTtBQURGOztBQUlBO0VBQ0UscUJBQUE7RUFDQSxhQUFBO0FBREY7O0FBSUE7RUFDRSxlQUFBO0VBQ0Esa0JBQUE7RUFDQSxXQUFBO0FBREY7QUFHRTtFQUNFLFlBQUE7RUFDQSxVQUFBO0VBQ0EsV0FBQTtBQURKOztBQUtBO0VBQ0UsZ0JBQUE7QUFGRjs7QUFLQTtFQUNFLGtCQUFBO0FBRkYiLCJmaWxlIjoibGF5b3V0LmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiOmhvc3QtY29udGV4dCgubm8tcGFkZGluZykge1xuICAuY29udGVudCB7XG4gICAgcGFkZGluZzogMDtcbiAgfVxufVxuXG4uY29udGVudCB7XG4gIG92ZXJmbG93OiBoaWRkZW47XG59XG5cbi5oZWFkZXIge1xuICBkaXNwbGF5OiBmbGV4O1xuICB3aWR0aDogMTAwJTtcbn1cblxuLnRpdGxlYmFyIHtcbiAgYWxpZ24taXRlbXM6IGJhc2VsaW5lO1xuICBwYWRkaW5nOiAxNnB4O1xufVxuXG4uYmFjay1idXR0b24ge1xuICBjdXJzb3I6IHBvaW50ZXI7XG4gIHRleHQtYWxpZ246IGNlbnRlcjtcbiAgd2lkdGg6IDI0cHg7XG5cbiAgc3B4LWljb24ge1xuICAgIGhlaWdodDogMjRweDtcbiAgICBwYWRkaW5nOiAwO1xuICAgIHdpZHRoOiAyNHB4O1xuICB9XG59XG5cbi5wYWdlLXRpdGxlIHtcbiAgbWFyZ2luLWxlZnQ6IDhweDtcbn1cblxuLmJhY2staWNvbiB7XG4gIHBhZGRpbmctbGVmdDogMTZweDtcbn1cbiJdfQ== */`, "",{"version":3,"sources":["webpack://./apps/service-point/ng/src/app/layout/components/layout/layout.component.scss"],"names":[],"mappings":"AACE;EACE,UAAA;AAAJ;;AAIA;EACE,gBAAA;AADF;;AAIA;EACE,aAAA;EACA,WAAA;AADF;;AAIA;EACE,qBAAA;EACA,aAAA;AADF;;AAIA;EACE,eAAA;EACA,kBAAA;EACA,WAAA;AADF;AAGE;EACE,YAAA;EACA,UAAA;EACA,WAAA;AADJ;;AAKA;EACE,gBAAA;AAFF;;AAKA;EACE,kBAAA;AAFF;AACA,onCAAonC","sourcesContent":[":host-context(.no-padding) {\n  .content {\n    padding: 0;\n  }\n}\n\n.content {\n  overflow: hidden;\n}\n\n.header {\n  display: flex;\n  width: 100%;\n}\n\n.titlebar {\n  align-items: baseline;\n  padding: 16px;\n}\n\n.back-button {\n  cursor: pointer;\n  text-align: center;\n  width: 24px;\n\n  spx-icon {\n    height: 24px;\n    padding: 0;\n    width: 24px;\n  }\n}\n\n.page-title {\n  margin-left: 8px;\n}\n\n.back-icon {\n  padding-left: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
